<div class="chat-panel" [class.compact]="compact" data-testid="test-panel">
  <header class="chat-header">
    <div class="chat-title">
      <i class="fa fa-flask me-2"></i>
      <span>Testar Agente</span>
    </div>
    <span class="chat-retention" *ngIf="agentId" data-testid="test-panel-retention">Testes ficam salvos por 7 dias</span>
    <button
      type="button"
      class="btn-clear"
      *ngIf="messages.length > 0"
      (click)="clearChat()"
      ngbTooltip="Limpar conversa"
      data-testid="btn-clear-chat"
    >
      <i class="fa fa-trash"></i>
    </button>
  </header>

  <!-- O teste chama o modelo de verdade e é debitado como uma conversa (CU-17tm466qj1v). -->
  <div class="notice notice--warning notice--sm chat-billing-notice" role="note" data-testid="test-panel-billing-notice">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    <div class="notice__body">{{ billingNotice }}</div>
  </div>

  <div *ngIf="!ready" class="chat-empty-state" data-testid="test-panel-no-agent">
    <i class="fa fa-info-circle"></i>
    <p>{{ draft ? draftHint : 'Salve o agente para começar a testar.' }}</p>
  </div>

  <div *ngIf="ready" #messagesContainer class="chat-messages" data-testid="chat-messages">
    <div *ngIf="messages.length === 0 && !loadingHistory" class="chat-empty-state">
      <i class="fa fa-comments-o"></i>
      <p>Envie uma mensagem para testar o agente.</p>
    </div>
    <div *ngIf="loadingHistory && messages.length === 0" class="chat-empty-state" data-testid="test-panel-loading">
      <i class="fa fa-spinner fa-spin"></i>
      <p>Carregando os testes dos últimos 7 dias…</p>
    </div>

    <div
      *ngFor="let m of messages; let i = index"
      class="chat-bubble"
      [class.user]="m.role === 'user'"
      [class.assistant]="m.role === 'assistant'"
      [attr.data-testid]="'chat-bubble-' + m.role"
    >
      <div class="bubble-content">{{ m.content }}</div>
      <div *ngIf="m.role === 'assistant' && m.costMicros !== null && m.costMicros !== undefined" class="bubble-meta" data-testid="chat-bubble-cost"
           ngbTooltip="Valor descontado do saldo da carteira por esta resposta">
        {{ m.costMicros | moneyMicros : 'BRL' : 'pt-BR' : 3 : 3 }}
      </div>
    </div>

    <div *ngIf="isTesting" class="chat-bubble assistant typing" data-testid="chat-typing">
      <div class="bubble-content">
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
      </div>
    </div>
  </div>

  <div *ngIf="ready" class="chat-input">
    <textarea
      #messageInput
      class="form-control"
      rows="1"
      placeholder="Digite uma mensagem..."
      [(ngModel)]="testMessage"
      [ngModelOptions]="{ standalone: true }"
      (keydown)="onKeydown($event)"
      (input)="autoGrow(messageInput)"
      [disabled]="isTesting"
      data-testid="input-test-message"
    ></textarea>
    <button
      type="button"
      class="btn-send"
      [disabled]="!canTest"
      (click)="sendMessage()"
      aria-label="Enviar"
      data-testid="btn-run-test"
    >
      <i class="fa" [class.fa-paper-plane]="!isTesting" [class.fa-spinner]="isTesting" [class.fa-spin]="isTesting"></i>
    </button>
  </div>
</div>
